import { UserPermissions } from '@centecomm/portal-service';
import { FeatureConfiguration } from 'Core/Types/FeatureConfiguration';
import ReportsNavigationIcon from 'Icons/NavigationItem/Reports';
import React from 'react';
import { LoadingContent } from 'Shared/PageElements';

const LazyReportSettingsPage = React.lazy(() => import('./Pages'));

const companyConfiguration: FeatureConfiguration = {
    name: 'administrationFeature:system.reports.title',
    navigationItem: {
        route: {
            text: 'administrationFeature:sidebar.system.reports.title',
            url: '/report-settings',
            Icon: ReportsNavigationIcon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyReportSettingsPage />
                </React.Suspense>
            ),
            tenantRoot: null,
        },
        isGloballyAccessible: false,
        permissions: [UserPermissions.ManageAdminConfig],
    },
    disableFeature: [],
};

export default companyConfiguration;
